import IndividualUnitPage from './IndividualUnitPage';

export default IndividualUnitPage;
